import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var disallowInput = _ref.disallowInput;
  return {
    dropdownBody: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2])
    },
    input: {
      cursor: disallowInput ? "pointer" : void 0
    }
  };
});
export default useStyles;